import { debounce, throttle, clamp, TimeUtil } from '@visactor/vutils';

export { debounce, throttle, clamp };

export * from './array';
export * from './color';
export * from './debug';
export * from './env';
export * from './id';
export * from './math';
export * from './model';
export * from './object';
export * from './scale';
export * from './space';
export * from './type';
export * from './theme';
export * from './spec';
export * from './text';
export * from './data';
export * from './hierarchy';
export * from './style';

export const Utils = { TimeUtil };
